export const Tableau = [
    { key: "5A - 15A", value: "5A - 15A", label: "5-15AMP" },
    { key: "10A - 30A", value: "10A - 30A", label: "10-30AMP" },
  ];